
<div v-if="!isDoublonProfession" :class="jel_getClassObject(content)">
  <label class="font-weight-normal m-0"> {{ content.titre }} </label>
  <Paragraphe :content="content" />
</div>
